
import { bulkHomeService } from "@/services/homeServices";
import { BulkHomeState } from "@/types/home";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

// Initial State
const initialState: BulkHomeState = {
  manufacturers: null,
  subCategories: [],
  products: [],
  SKU_Details:[],
  selectedSKU:null,
  productDetail:null,
  loading: false,
  error: null,
};

// ✅ Fetch Manufacturers API
export const fetchManufacturers = createAsyncThunk(
  "bulkHome/fetchManufacturers",
  async (_, { rejectWithValue }) => {
    try {
      return await bulkHomeService.fetchManufacturers();
    } catch (error: unknown) {
      if (error instanceof Error) {
        return rejectWithValue(error.message);
      }
      return rejectWithValue("Error fetching manufacturers");
    }
  }
);

// ✅ Fetch Bulk Products API
export const fetchProducts = createAsyncThunk(
  "bulkHome/fetchProducts",
  async (manufactureName: string, { rejectWithValue }) => {
    try {
      return await bulkHomeService.fetchProducts(manufactureName);
    } catch (error: unknown) {
      if (error instanceof Error) {
        return rejectWithValue(error.message);
      }
      return rejectWithValue("Error fetching bulk products");
    }
  }
);

// ✅ Fetch Bulk Products API
export const fetchProductsWithProductID = createAsyncThunk(
  "bulkHome/fetchProductsWithProductID",
  async (productID: string, { rejectWithValue }) => {
    try {
      return await bulkHomeService.fetchProductsWithProductID(productID);
    } catch (error: unknown) {
      if (error instanceof Error) {
        return rejectWithValue(error.message);
      }
      return rejectWithValue("Error fetching bulk product");
    }
  }
);

// ✅ Bulk Listing Slice
const homeSlice = createSlice({
  name: "bulkListing",
  initialState,
  reducers: {
    setSelectedSKU: (state, action) => {
      state.selectedSKU = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchManufacturers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchManufacturers.fulfilled, (state, action) => {
        state.loading = false;
        state.manufacturers = action.payload;
      })
      .addCase(fetchManufacturers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      .addCase(fetchProducts.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProducts.fulfilled, (state, action) => {
        state.loading = false;
        state.products = action.payload.product;
        state.subCategories = action.payload.SubCategories;
        state.SKU_Details = action.payload.SKU_Details;
      })
      .addCase(fetchProducts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(fetchProductsWithProductID.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProductsWithProductID.fulfilled, (state, action) => {
        state.loading = false;
        state.productDetail = action.payload;
      })
      .addCase(fetchProductsWithProductID.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export const { setSelectedSKU  } = homeSlice.actions;

export default homeSlice.reducer;
